var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.18321C15.5234 8.18321 20 6.35023 20 4.09161C20 1.83298 15.5234 0 10 0C4.47656 0 0 1.83298 0 4.09161C0 6.35023 4.47656 8.18321 10 8.18321ZM10 14.7252C6.18359 14.7252 2.80859 13.824 0.679688 12.432C0.246094 12.8922 0 13.3869 0 13.9084C0 16.167 4.47656 18 10 18C15.5234 18 20 16.167 20 13.9084C20 13.3869 19.7539 12.8922 19.3203 12.4359C17.1914 13.824 13.8164 14.7252 10 14.7252ZM10 9.81679C6.18359 9.81679 2.80859 8.91564 0.679688 7.52365C0.246094 7.98381 0 8.47848 0 9C0 11.2586 4.47656 13.0916 10 13.0916C15.5234 13.0916 20 11.2586 20 9C20 8.47848 19.7539 7.98381 19.3203 7.52748C17.1914 8.91564 13.8164 9.81679 10 9.81679Z",
    fill: "#626262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoin);
export default __webpack_public_path__ + "static/media/icon-coin.88a70673ab8828b7827f2b53fac1ecf4.svg";
export { ForwardRef as ReactComponent };